import * as types from '../actions/action-types';
import {SET_HIDE_COLLECTION_LOCATION_INFO} from '../actions/action-types';
import PudoInitialState from './PudoInitialState';

export default function pudoReducer(state = PudoInitialState, action) {
  switch (action.type) {
    case types.LOAD_PUDO_SAVED_ADDRESSES_SUCCESS:
      return {
        ...state,
        savedAddresses: action.savedAddresses,
        initialAddressLength: action.setInitialAddressLength && state.initialAddressLength === 0 ? action.savedAddresses.length : state.initialAddressLength,
        selectedCollectionPoint: action.savedAddresses.length - 1,
      };
    
    case types.ADD_PUDO_ADDRESS_SUCCESS: {
      const savedAddresses = [...state.savedAddresses, action.addressToAdd];
      return {
        ...state,
        savedAddresses,
        selectedCollectionPoint: savedAddresses.length - 1,
      };
    }
    
    case types.CHANGE_PUDO_ADDRESS_SUCCESS: {
      const savedAddresses = [...state.savedAddresses];
      savedAddresses[action.indexOfNewCollectionPoint] = action.addressToAdd;

      return {
        ...state,
        savedAddresses,
        selectedCollectionPoint: action.indexOfNewCollectionPoint,
      };
    }
    
    case types.UPDATE_PUDO_CURRENT_POSITION_SUCCESS:
    case types.SET_CURRENT_SELECTED_LOCATION_SUCCESS:
      return {...state, currentLocation: action.currentLocation, mapCenter: action.currentLocation.latlng};
    
    case types.GET_PUDO_COLLECTION_POINTS_SUCCESS:
      return {...state, collectionPoints: action.collectionPoints};
    
    case types.ACTIVATE_ADD_COLLECTION_POINT_SUCCESS:
      return {
        ...state,
        isAddCollectionPoint: true,
        hideCollectionPoint: false,
      };
    
    case types.DEACTIVATE_ADD_COLLECTION_POINT_SUCCESS:
      return {...state, isAddCollectionPoint: action.isAddCollectionPoint};
  
    case types.UPDATE_MAP_ZOOM:
    case types.SET_COLLECTION_MAP_ZOOM:
      return {...state, mapZoom: action.mapZoom};
      
    case types.ENTER_COLLECTION_POINT:
      return {...state, activeCollectionPoint: action.key};
  
    case types.MAKE_ACTIVE_COLLECTION_POINT:
      return {...state, activeCollectionPoint: action.key};
  
    case types.UPDATE_SELECTED_ACTIVE_COLLECTION_POINT:
      return {...state, selectedActiveCollectionPoint: action.key};
    
    case types.SET_COLLECTION_POINT_LOADING:
      return {...state, collectionPointLoading: action.collectionPointLoading};
    
    case types.ACTIVATE_DISPLAY_COLLECTION_POINT_INFO_SUCCESS:
      return {...state, isDisplayCollectionPointInfo: action.isDisplayCollectionPointInfo};
    
    case types.DISPLAY_COLLECTION_POINT_SUCCESS:
      return {...state, ...action.point};
    
    case types.HIDE_ADD_COLLECTION_POINT_SUCCESS:
      return {...state, hideCollectionPoint: action.hideCollectionPoint};
    
    case types.DEACTIVATE_DISPLAY_COLLECTION_POINT_INFO_SUCCESS:
      return {...state, ...action.newState, mapCenter: state.currentLocation.latlng};
    
    case types.SET_DISPLAY_COLLECTOR_NAME_STATUS: {
      return {...state, isDisplayCollectorName: action.isDisplayCollectorName, indexOfAddressToShowInCollectorName: action.selectedPudoAddressIndex};
    }
  
    case types.SET_DISPLAY_FILTERS_STATUS:
      return {...state, isDisplayFilters: action.isDisplayFilters};
  
    case types.SET_FILTER_VALUES_TO_DEFAULT:
      return {...state, filterValues: action.filterValues};
  
    case types.SET_DISPLAY_LIST_VIEW_STATUS:
      return {...state, isDisplayListView: action.isDisplayListView};
    
    case types.UPDATE_SELECTED_COLLECTION_POINT:
      if (action.selectedCollectionPoint === 'latest') {
        return {...state, selectedCollectionPoint: state.savedAddresses.length - 1};
      }
      return {...state, selectedCollectionPoint: action.selectedCollectionPoint};
    
    case types.SET_COLLECTOR_NAME:
      return {...state, collectorName: action.name};
      
    case types.SET_COLLECTION_COLLECTOR_NAME:
      return {...state, collectorName: action.value};
      
    case types.SET_COLLECTION_SEARCH_DESCRIPTION:
      return {...state, searchDescription: action.searchDescription};
      
    case types.SET_FILTER_COLLECTION_POINTS_SUCCESS:
      return {...state, ...action.newState};
  
    case types.UPDATE_COLLECTION_POINTS:
      return {...state, collectionPoints: action.collectionPoints};
  
    case types.SET_INITIAL_COLLECTION_POINTS:
      return {...state, initialCollectionPoints: action.collectionPoints};
      
    case types.UPDATE_HAS_COLLECTION_POINTS:
    case types.SET_HAS_COLLECTION_LOCATIONS_STATUS:
      return {...state, hasCollectionPoints: action.hasCollectionPoints};
  
    case types.UPDATE_COLLECTION_POINTS_AMOUNT_TO_DISPLAY:
      return {...state, collectionPointsAmountToDisplay: action.collectionPointsAmountToDisplay};
  
    case types.UPDATE_COLLECTION_POINTS_TO_DISPLAY:
      return {...state, collectionPointsToDisplay: action.collectionPointsToDisplay};
  
    //  New Collection
    case types.SET_COLLECTION_LOCATIONS:
      return {
        ...state,
        collectionPoints: action.collectionLocations,
        initialCollectionPoints: action.collectionLocations,
        collectionPointsToDisplay: action.collectionLocationsToDisplay,
        hasCollectionPoints: action.hasCollectionLocationsStatus,
        filterValues: [],
        selectedActiveCollectionPoint: action.selectedCollectionLocation,
        isDisplayCollectionPointInfo: !action.shouldDefaultToListView,
        isDisplayListView: action.shouldDefaultToListView,
        isDisplayCollectorName: false,
      };
      
    case types.SET_DISPLAY_COLLECTION_LOCATION_INFO:
      return {
        ...state,
        isDisplayCollectionPointInfo: true,
        isDisplayCollectorName: false,
        mapZoom: 15,
        mapCenter: action.mapCenter,
        displayCollectionPoint: action.indexToSelectAndDisplay,
        selectedActiveCollectionPoint: action.indexToSelectAndDisplay,
      };
      
    case SET_HIDE_COLLECTION_LOCATION_INFO:
      return {
        ...state,
        isDisplayCollectionPointInfo: false,
      };
  
    case types.SET_DISPLAY_COLLECTION_COLLECTOR_NAME:
      return {
        ...state,
        isDisplayCollectorName: true,
        mapZoom: 17,
        mapCenter: action.mapCenter,
        displayCollectionPoint: action.indexToSelectAndDisplay,
        selectedActiveCollectionPoint: action.indexToSelectAndDisplay,
      };
  
    case types.SET_HIDE_COLLECTION_COLLECTOR_NAME:
      return {
        ...state,
        isDisplayCollectorName: false,
      };
      
    case types.SET_COLLECTION_LOCATIONS_TO_DISPLAY:
      return {
        ...state,
        collectionPointsToDisplay: action.collectionLocationsToDisplay,
        collectionPointsAmountToDisplay: action.amountOfCollectionLocationsToDisplay,
      };
      
    default:
      return state;
  }
}
